import {createStore, applyMiddleware, compose} from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import history from './history';
import rootReducer from './reducers/index';
import logger from 'redux-logger';

const middleware = routerMiddleware(history);
export default function configureStore() {
  // const store = createStore(rootReducer, compose(
  //   applyMiddleware(middleware, thunk, logger),
  //   window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  // ));
  const store = createStore(rootReducer,
    applyMiddleware(
      middleware, thunk
      //logger
      )
  );

  history.listen((i) => {
    store.dispatch({
      type: 'SET_CONFIG',
      config: {
        menuShow: true,
      }
    });
    store.dispatch({
      type: 'SET_CONFIG',
      config: {
        collapsed: false,
      }
    });
  });

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers/index')
      store.replaceReducer(nextRootReducer)
    })
  }
  return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.js